import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4" data-testid="page-404">
      <div className="text-center max-w-md">
        <div className="font-serif text-7xl text-[#B8935A]">404</div>
        <h1 className="font-serif text-3xl text-[#0F172A] mt-6">Page introuvable</h1>
        <p className="text-[#64748B] mt-4">
          La page que vous cherchez n'existe pas ou a été déplacée.
        </p>
        <Link to="/" className="gpi-btn-outline mt-10">
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
